import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'
import Lazyload from 'react-lazy-load'
import Testimonials from "./TestimonialsHome"
import {Trans, useTranslation, useI18next} from 'gatsby-plugin-react-i18next';
import { useLocation } from '@reach/router';

const GlobalEmployeeEngagement = () => {
    const location = useLocation();
    const { pathname } = location;
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 soln-hero ge-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h1 className="font-weight-semibold hero-heading text-center no-br">
                        <Trans>Engaging Employees <br/>Worldwide!</Trans>
                    </h1>
                    <p className="hero-para font-weight-normal text-center no-br">
                        <Trans>Tailored initiatives for multi-national companies, <br/>embracing diversity in every step.</Trans>
                    </p>
                    <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section className="position-relative pb-0 vfitsoln ge-2">
            <div className="feat_box sect-white-col-2 shadow feat_pb0 mb-0">
                <div className="d-flex m-d-block container custom_container p0">
                    <div className="col-12 col-md-6 p-0">
                        <div className="col-12 p-0">
                            <h2 className='font-weight-semibold py-2 section-heading green-text'><Trans>How to engage a diverse, global workforce in a <span>unified wellness</span> initiative?</Trans></h2>
                            <p className='section-para font-weight-normal'><Trans>Our platform caters to multiple cultures, languages and regions, ensuring every employee feels included.</Trans></p>
                        </div>
                    </div>
                    <div className='cta-img'>
                        <div className='d-flex justify-content-center'>
                            <img loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/v1699961765/VantageFit/2023/Global_Engagement-painpoint.webp" alt="How to engage a diverse, global workforce in a unified wellness initiative?" width="600" height="660"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <h2 className="section-heading section-heading-top font-weight-semibold text-center no-br"><Trans>Experience a Worldwide Wellness Approach</Trans></h2>
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Flexible Scheduling</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Activities and challenges that cater to different time zones.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'> <Trans>Plan, organize challenges and activities accommodating various time zones.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Ensure inclusivity with events tailored to different regions.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Adapt activities to suit the diverse schedules of participants.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1703073873/VantageFit/2023/Global_Engagement-flexible-scheduling.webp" loading='lazy' alt="Flexible Scheduling" width="493" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Multi-Language Support</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Engage employees in their preferred language.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Foster engagement by supporting multiple languages.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Encourage employees to participate in their language of choice.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Engage your workforce effectively by accommodating diverse language preferences.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1699961765/VantageFit/2023/Global_Engagement-Multi-Lingual_Support.webp" loading='lazy' alt="Multi-Lingual Support" width="730" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Culturally Diverse Challenges</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>From Diwali step challenges in India to a Christmas marathon in the US, our platform offers culturally relevant activities.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Provide diverse challenges like Diwali step challenges and Christmas marathons.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Tailor challenges to align with cultural celebrations worldwide.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Engage employees with activities that resonate with various cultural backgrounds.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703073873/VantageFit/2023/Global_Engagement-culturally_diverse_challenges.webp`)} loading='lazy' alt="Culturally Diverse Challenges" width="560" height="600" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Global Leaderboards</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Foster healthy competition among regions and celebrate global top performers.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Instigate friendly competition among different regions.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Recognize and celebrate top achievers on a global scale.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Foster a sense of achievement with global leaderboards and celebrations.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1700126319/VantageFit/2023/Global_Engagement-Global_Leaderboards.webp`)} loading='lazy' alt="Global Leaderboards" width="444" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="gray-gradient-bg section-pdn-1">
            <div className="container custom_container mx-auto relative">
                <div className="px-5">
                    <h2 className="section-heading text-center pt-0">
                    <Trans>Real people, real results</Trans>
                    </h2>
                    <p className="col-12 sub-para text-center f-400 mt-0 mb-5 pb-5">
                    <Trans>Vantage Fit speaks for itself, but our
                        customer reviews speak even louder.</Trans>
                    </p>
                    {/* <div className="col-lg-12 testimonialcarousel mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1701422593/VantageFit/2023/vfit-default-gravatar_1_1.png" alt="romod Patil" className="max-w lozad" width="218" height="218" loading="lazy"/></div>
                            <div className="testi_profile_name p-4">
                                <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Promod Patil</h3>
                                <p className="font-weight-light text-center text-lg-left text-white mb-0">KEVA</p>
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                            <div className="col-12 col-md-11 d-flex flex-column">
                                <p className="section-para text-center text-lg-left mb-0">The fact that our employees could easily download the application and access all the minute details about the Fit-o-meter challenge on their phones motivated them to participate in the program. Vantage Fit app helped us to create higher engagement levels among our employees.</p>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-lg-12 testimonialcarousel d-none d-md-flex mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1700137313/VantageFit/2023/vfit-default-gravatar_1_1.png" alt="Promod Patil" className="max-w lozad" width="218" height="218" loading="lazy"/></div>
                            <div className="testi_profile_name p-4">
                                <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Promod Patil</h3>
                                <p className="font-weight-light text-center text-lg-left text-white mb-0">KEVA</p>
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                            <div className="col-12 col-md-11 d-flex flex-column">
                                <p className="section-para text-center text-lg-left mb-0"><Trans>The fact that our employees could easily download the application and access all the minute details about the Fit-o-meter challenge on their phones motivated them to participate in the program. Vantage Fit app helped us to create higher engagement levels among our employees.</Trans></p>
                            </div>
                        </div>
                    </div>
                    <div className="d-md-none d-block p-3" style={{ background: 'white', boxShadow: '1px 0px 20px rgba(0,0,0,0.3)', borderRadius: '25px' }}>
                        <div className="p-2" style={{ background: '#1d2227', borderRadius: '40px', display: 'grid', justifyContent: 'center' }}>
                            <img style={{ marginLeft: '0.5rem !important', marginTop: '0.5rem', marginBottom: '1rem' }} src="https://res.cloudinary.com/vantagecircle/image/upload/v1700218240/VantageFit/2023/vfit-default-gravatar_1_1.png" alt="Promod Patil" className="mx-auto" width="218" height="218" loading="lazy"/>
                            <h3 className="font-weight-bold text-center text-white mb-0">Promod Patil</h3>
                            <p className="font-weight-light text-center text-white my-3">KEVA</p>
                        </div>
                        <p className="section-para text-center text-lg-left my-4"><Trans>The fact that our employees could easily download the application and access all the minute details about the Fit-o-meter challenge on their phones motivated them to participate in the program. Vantage Fit app helped us to create higher engagement levels among our employees.</Trans></p>

                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative section-pdn-1 pl-0 pr-0">
            <div className="logo-container">
                <h2 className="section-heading mb-5 no-br clr50">FAQ</h2>
                <div id="accordion" className="">
                    <Card>
                        <Button id="faq1">
                        <Trans>Is it possible to arrange a unified challenge for employees working across diverse global time zones?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq1">
                            <CardBody>
                            <Trans>Yes, it is possible to arrange a challenge in Vantage Fit that caters to employees in different time zones.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq2">
                        <Trans>Can we suggest region-specific activities?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq2">
                            <CardBody>
                            <Trans>Yes, we welcome region-specific activity suggestions to tailor challenges to your preferences and ensure a more personalized experience.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq3">
                        <Trans>Is the platform available in multiple languages?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq3">
                            <CardBody>
                            <Trans>Yes, Vantage Fit offers multi-language support to cater to a global audience, making the platform accessible to users worldwide.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                </div>
            </div>
        </section>

        <section className="ge-btm ctabtm multi-activity hero-bg position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                    <Trans>Embrace Global Employee Wellness <br/>with Vantage Fit!</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5 no-br">
                    <Trans>Join leading multinational companies in <br/>creating a culture of health and unity.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mt-4 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default GlobalEmployeeEngagement
